/* OF TWO Concept 1: Thread Studio and homepage behaviour. Generated by redesign/tools/build-shopify.js; edit the sources, not this file. */
/* thread renderer */
(function () {
var OT = window.OT = window.OT || {};
var i, v;
var LIN = new Float32Array(256), ENC = new Uint8ClampedArray(4096);
for (i = 0; i < 256; i++) { v = i / 255; LIN[i] = v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }
for (i = 0; i < 4096; i++) { v = i / 4095; ENC[i] = Math.round(255 * (v <= 0.0031308 ? v * 12.92 : 1.055 * Math.pow(v, 1 / 2.4) - 0.055)); }
function hexLin(h) { return [LIN[parseInt(h.slice(1, 3), 16)], LIN[parseInt(h.slice(3, 5), 16)], LIN[parseInt(h.slice(5, 7), 16)]]; }
function clamp01(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
function blur(src, w, h, r, passes) {
var a = new Float32Array(src), b = new Float32Array(src.length), inv = 1 / (2 * r + 1), x, y, acc, row, p;
for (p = 0; p < passes; p++) {
for (y = 0; y < h; y++) {
row = y * w; acc = 0;
for (x = -r; x <= r; x++) acc += a[row + (x < 0 ? 0 : x >= w ? w - 1 : x)];
for (x = 0; x < w; x++) {
b[row + x] = acc * inv;
acc += a[row + (x + r + 1 >= w ? w - 1 : x + r + 1)] - a[row + (x - r < 0 ? 0 : x - r)];
}
}
for (x = 0; x < w; x++) {
acc = 0;
for (y = -r; y <= r; y++) acc += b[(y < 0 ? 0 : y >= h ? h - 1 : y) * w + x];
for (y = 0; y < h; y++) {
a[y * w + x] = acc * inv;
acc += b[(y + r + 1 >= h ? h - 1 : y + r + 1) * w + x] - b[(y - r < 0 ? 0 : y - r) * w + x];
}
}
}
return a;
}
function otsu(vals) {
var hist = new Float64Array(256), n = vals.length, k, sum = 0, sumB = 0, wB = 0, best = -1, thr = 128;
for (k = 0; k < n; k++) hist[Math.max(0, Math.min(255, Math.round(vals[k] * 255)))]++;
for (k = 0; k < 256; k++) sum += k * hist[k];
for (k = 0; k < 256; k++) {
wB += hist[k]; if (!wB) continue;
var wF = n - wB; if (!wF) break;
sumB += k * hist[k];
var mB = sumB / wB, mF = (sum - sumB) / wF, between = wB * wF * (mB - mF) * (mB - mF);
if (between > best) { best = between; thr = k; }
}
return (thr + 0.5) / 255;
}
function bil(a, w, h, x, y) {
var x0 = Math.floor(x), y0 = Math.floor(y), fx = x - x0, fy = y - y0;
if (x0 < 0 || y0 < 0 || x0 >= w - 1 || y0 >= h - 1) return -1;
var k = y0 * w + x0;
return a[k] * (1 - fx) * (1 - fy) + a[k + 1] * fx * (1 - fy) + a[k + w] * (1 - fx) * fy + a[k + w + 1] * fx * fy;
}
function fitFree(pts, c0) {
var M = [[0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0]], V = [0, 0, 0, 0];
pts.forEach(function (p) {
var u = (p[0] - c0) / c0, w = (p[1] - c0) / c0, row = [u * u, w * w, u, w], a, b;
for (a = 0; a < 4; a++) { V[a] += row[a]; for (b = 0; b < 4; b++) M[a][b] += row[a] * row[b]; }
});
var s = solve(M, V), cu = -s[2] / (2 * s[0]), cw = -s[3] / (2 * s[1]), G = 1 + s[0] * cu * cu + s[1] * cw * cw;
return { cx: c0 + cu * c0, cy: c0 + cw * c0, a: Math.sqrt(G / s[0]) * c0, b: Math.sqrt(G / s[1]) * c0 };
}
function fitEllipse(pts, k) {
var M = [[0, 0, 0], [0, 0, 0], [0, 0, 0]], V = [0, 0, 0], ox = 0, oy = 0;
pts.forEach(function (p) { ox += p[0]; oy += p[1] / k; });
ox /= pts.length; oy /= pts.length;
pts.forEach(function (p) {
var x = p[0] - ox, y = p[1] / k - oy, row = [x, y, 1], rhs = -(x * x + y * y), a, b;
for (a = 0; a < 3; a++) { V[a] += row[a] * rhs; for (b = 0; b < 3; b++) M[a][b] += row[a] * row[b]; }
});
var s = solve(M, V), cx = -s[0] / 2, cy = -s[1] / 2, r = Math.sqrt(cx * cx + cy * cy - s[2]);
return { cx: cx + ox, cy: (cy + oy) * k, a: r, b: r * k };
}
function solve(M, V) {
var n = V.length, A = M.map(function (r, k) { return r.concat([V[k]]); }), r, c, k, t, f, x = [];
for (r = 0; r < n; r++) {
var p = r; for (k = r + 1; k < n; k++) if (Math.abs(A[k][r]) > Math.abs(A[p][r])) p = k;
t = A[r]; A[r] = A[p]; A[p] = t;
for (k = r + 1; k < n; k++) { f = A[k][r] / A[r][r]; for (c = r; c <= n; c++) A[k][c] -= f * A[r][c]; }
}
for (r = n - 1; r >= 0; r--) { t = A[r][n]; for (c = r + 1; c < n; c++) t -= A[r][c] * x[c]; x[r] = t / A[r][r]; }
return x;
}
function ellDist(e, p) {
var u = (p[0] - e.cx) / e.a, w = (p[1] - e.cy) / e.b;
return (Math.sqrt(u * u + w * w) - 1) * (e.a + e.b) / 2;
}
function edgePoints(Ls, w, h, cx, cy, R, thr, circleDark) {
var pts = [], step = 0.5, k, r;
function inCircle(val) { return circleDark ? val < thr : val > thr; }
for (k = 0; k < 360; k++) {
var th = k * Math.PI / 180, dx = Math.cos(th), dy = Math.sin(th), last = -1;
for (r = 0.8 * R; r <= 1.22 * R; r += step) {
var v1 = bil(Ls, w, h, cx + dx * r, cy + dy * r), v2 = bil(Ls, w, h, cx + dx * (r + step), cy + dy * (r + step));
if (v1 < 0 || v2 < 0) break;
if (inCircle(v1) && !inCircle(v2)) {
var vi = bil(Ls, w, h, cx + dx * (r - 4), cy + dy * (r - 4)), vo = bil(Ls, w, h, cx + dx * (r + 5), cy + dy * (r + 5));
if (vi >= 0 && vo >= 0 && inCircle(vi) && !inCircle(vo)) last = r + step * (v1 - thr) / (v1 - v2);
}
}
if (last > 0) pts.push([cx + dx * last, cy + dy * last]);
}
return pts;
}
OT.threadAnalyse = function (img, nature, r0, aspect) {
var w = img.naturalWidth, h = img.naturalHeight, n = w * h, k, x, y;
var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
var cx2 = cv.getContext('2d', { willReadFrequently: true }); cx2.drawImage(img, 0, 0);
var d = cx2.getImageData(0, 0, w, h).data;   // throws on a cross-origin photo; the caller falls back to vector art
var L = new Float32Array(n), lg = new Float32Array(n);
for (k = 0; k < n; k++) {
var Y = 0.2126 * LIN[d[k * 4]] + 0.7152 * LIN[d[k * 4 + 1]] + 0.0722 * LIN[d[k * 4 + 2]];
L[k] = Math.pow(Y, 1 / 2.2);         // lightness, for telling the two threads apart
lg[k] = Math.log(Y + 0.004);         // log light, for the stitch relief
}
var Ls = blur(L, w, h, 1, 2);
var R = (r0 || 0.395) * w, c0x = w / 2, c0y = h / 2, vals = [];
for (y = 0; y < h; y += 2) for (x = 0; x < w; x += 2) {
if ((x - c0x) * (x - c0x) + (y - c0y) * (y - c0y) < 0.64 * R * R) vals.push(Ls[y * w + x]);
}
var thr = otsu(vals), circleDark = nature !== 'bad';
var all = edgePoints(Ls, w, h, c0x, c0y, R, thr, circleDark), pts, e, pass;
function robust(fit) {
pts = all; e = fit(pts);
for (pass = 0; pass < 3; pass++) {
pts = all.filter(function (p) { return Math.abs(ellDist(e, p)) < (pass ? 2 : 4); });
e = fit(pts);
}
}
if (aspect) robust(function (p) { return fitEllipse(p, aspect); });
else {
robust(function (p) { return fitFree(p, w / 2); });
var asp = e.b / e.a;
if (!(asp >= 0.95 && asp <= 1)) { asp = asp > 1 ? 1 : 0.95; robust(function (p) { return fitEllipse(p, asp); }); }
}
var ravg = (e.a + e.b) / 2, NB = 90, off = new Float32Array(NB), seen = [], b0;
for (b0 = 0; b0 < NB; b0++) seen.push([]);
all.forEach(function (p) {
var dd = ellDist(e, p), t = Math.atan2((p[1] - e.cy) / e.b, (p[0] - e.cx) / e.a);
if (dd > -14 && dd < 8) seen[((Math.round(t / (2 * Math.PI) * NB) % NB) + NB) % NB].push(dd);
});
function med(a) { a = a.slice().sort(function (p1, p2) { return p1 - p2; }); return a[a.length >> 1]; }
function along(t, r) {   // lightness at radius r on angle t, averaged across 7 px
var c = Math.cos(t), sn = Math.sin(t), px = e.cx + c * r * e.a / ravg, py = e.cy + sn * r * e.b / ravg, acc = 0, cnt = 0, j, val;
for (j = -3; j <= 3; j++) { val = bil(Ls, w, h, px - sn * j, py + c * j); if (val >= 0) { acc += val; cnt++; } }
return cnt ? acc / cnt : -1;
}
for (b0 = 0; b0 < NB; b0++) {
if (seen[b0].length >= 2) { off[b0] = med(seen[b0]); continue; }
var t0 = b0 / NB * 2 * Math.PI, prof = [], sm = [], rr, lo = 1e9, at = 0;
for (rr = -27; rr <= 7; rr += 0.5) prof.push(along(t0, ravg + rr));
for (k = 2; k < prof.length - 2; k++) {
sm[k] = Math.min(prof[k - 2], prof[k - 1], prof[k], prof[k + 1], prof[k + 2]) < 0 ? 9
: (prof[k - 2] + 2 * prof[k - 1] + 3 * prof[k] + 2 * prof[k + 1] + prof[k + 2]) / 9;
lo = Math.min(lo, sm[k]);
}
for (k = 2; k < prof.length - 2; k++) if (sm[k] <= lo + 0.012) at = -27 + k * 0.5;
off[b0] = at;
}
var offM = new Float32Array(NB), offS = new Float32Array(NB), o;
for (b0 = 0; b0 < NB; b0++) {
o = med([-2, -1, 0, 1, 2].map(function (j) { return off[(b0 + j + NB) % NB]; }));
offM[b0] = o >= -1 ? 0 : o <= -4 ? o : -4 * (o + 1) * (o + 1) / 9;
}
for (b0 = 0; b0 < NB; b0++) {
for (o = 0, k = -3; k <= 3; k++) o += (4 - Math.abs(k)) * offM[(b0 + k + NB) % NB];
offS[b0] = o / 16;
}
function edgeAt(u, vv) {   // offset of the real edge from the ellipse, in px, at this direction
var f0 = (Math.atan2(vv, u) / (2 * Math.PI) * NB + NB) % NB, i0 = Math.floor(f0) % NB, i1 = (i0 + 1) % NB, fr = f0 - Math.floor(f0);
return offS[i0] * (1 - fr) + offS[i1] * fr;
}
var A = new Float32Array(n), F = new Float32Array(n), D = new Float32Array(n), band = 0.06;
function share(val) { var s = clamp01((val - thr + band) / (2 * band)); s = s * s * (3 - 2 * s); return circleDark ? s : 1 - s; }
for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
k = y * w + x;
var u = (x - e.cx) / e.a, vv = (y - e.cy) / e.b, q = Math.sqrt(u * u + vv * vv), dist = (1 - q) * ravg + edgeAt(u, vv) - 0.7;
if (dist < 3 && q > 0) {
var pull = 1 - (3.5 - Math.max(0, dist)) / (q * ravg);
F[k] = share(bil(Ls, w, h, e.cx + (x - e.cx) * pull, e.cy + (y - e.cy) * pull));
} else F[k] = share(Ls[k]);
dist -= dist < 6 ? 3 * F[k] : 0;
D[k] = dist; A[k] = clamp01(dist + 0.5);
}
var hard = new Float32Array(n);
for (k = 0; k < n; k++) hard[k] = F[k] > 0.5 ? 1 : 0;
var Fb = blur(hard, w, h, 2, 1), iA = new Float32Array(n), iB = new Float32Array(n);
for (k = 0; k < n; k++) {
var inner = clamp01((D[k] - 1.5) / 1.5);
iA[k] = inner * clamp01(1 - Fb[k] * 5);
iB[k] = inner * clamp01((Fb[k] - 0.8) * 5);
}
function localMean(wt) {
var num = new Float32Array(n);
for (k = 0; k < n; k++) num[k] = lg[k] * wt[k];
num = blur(num, w, h, 6, 2);
var den = blur(wt, w, h, 6, 2);
for (k = 0; k < n; k++) num[k] = den[k] > 1e-3 ? num[k] / den[k] : 0;
return num;
}
var muA = localMean(iA), muB = localMean(iB);
var lgSoft = blur(lg, w, h, 1, 1);
function stats(mu, wt, src) {
var s2 = 0, m1 = 0, m2 = 0, cnt = 0, dd;
for (k = 0; k < n; k++) if (wt[k] > 0.9) { dd = src[k] - mu[k]; s2 += dd * dd; m1 += mu[k]; m2 += mu[k] * mu[k]; cnt++; }
var mean = m1 / cnt;
return { sd: Math.sqrt(s2 / cnt) || 1, mean: mean, gsd: Math.sqrt(Math.max(1e-6, m2 / cnt - mean * mean)) };
}
var darkIsA = circleDark, srcA = darkIsA ? lgSoft : lg, srcB = darkIsA ? lg : lgSoft;
var sA = stats(muA, iA, srcA), sB = stats(muB, iB, srcB);
var tune = { dark: { kd: 0.13, sp: 0.014, from: 1.6 }, light: { kd: 0.18, sp: 0.018, from: 1.2 } };
var tA = darkIsA ? tune.dark : tune.light, tB = darkIsA ? tune.light : tune.dark;
var SH = new Float32Array(n), SP = new Float32Array(n);
for (k = 0; k < n; k++) {
if (A[k] <= 0) continue;
var isB = F[k] >= 0.5, st = isB ? sB : sA, mu = isB ? muB[k] : muA[k], tn = isB ? tB : tA;
var t = ((isB ? srcB : srcA)[k] - mu) / st.sd;   // fine stitch relief
var g = (mu - st.mean) / st.gsd;                 // broad light across the mark
t = t < -2.6 ? -2.6 : t > 2.6 ? 2.6 : t; g = g < -2.5 ? -2.5 : g > 2.5 ? 2.5 : g;
var seam = clamp01(1 - iA[k] - iB[k]);           // where the two threads meet, or near the outer edge
t = t * (1 - seam) - 0.3 * seam;
var rim = clamp01(1 - D[k] / 2.2);
SH[k] = Math.exp(tn.kd * t + 0.06 * g) * (1 - 0.1 * seam) * (1 - 0.18 * rim);
SP[k] = tn.sp * Math.pow(Math.max(0, t - tn.from), 1.3) + 0.01 * Math.max(0, g - 0.9);
}
return { w: w, h: h, A: A, F: F, SH: SH, SP: SP, e: e, thr: thr, edges: pts.length, off: off, offS: offS };
};
OT.threadPaint = function (m, canvas, hexA, hexB) {
if (canvas.width !== m.w) { canvas.width = m.w; canvas.height = m.h; }
var ctx = canvas.getContext('2d'), out = ctx.createImageData(m.w, m.h), o = out.data;
var a = hexLin(hexA), b = hexLin(hexB), A = m.A, F = m.F, SH = m.SH, SP = m.SP, n = m.w * m.h, k, j, f, s, p, r, g, bl;
for (k = 0, j = 0; k < n; k++, j += 4) {
if (A[k] <= 0) continue;
f = F[k]; s = SH[k]; p = SP[k];
r = (a[0] + (b[0] - a[0]) * f) * s + p;
g = (a[1] + (b[1] - a[1]) * f) * s + p;
bl = (a[2] + (b[2] - a[2]) * f) * s + p;
o[j] = ENC[r >= 1 ? 4095 : r <= 0 ? 0 : (r * 4095) | 0];
o[j + 1] = ENC[g >= 1 ? 4095 : g <= 0 ? 0 : (g * 4095) | 0];
o[j + 2] = ENC[bl >= 1 ? 4095 : bl <= 0 ? 0 : (bl * 4095) | 0];
o[j + 3] = A[k] * 255;
}
ctx.putImageData(out, 0, 0);
};
var cache = {};
OT.threadModel = function (mark) {
if (!mark.photo) return Promise.resolve(null);
if (cache[mark.id]) return cache[mark.id];
cache[mark.id] = new Promise(function (resolve) {
var img = new Image();
img.crossOrigin = 'anonymous';   // Shopify's image CDN sends CORS headers, so the canvas can read the photo
img.onload = function () {
try { resolve(OT.threadAnalyse(img, mark.nature, mark.r0, mark.aspect)); }
catch (err) { resolve(null); }
};
img.onerror = function () { resolve(null); };
img.src = mark.photo;
});
return cache[mark.id];
};
})();
;
/* studio + shared behaviour */
(function () {
var OT = window.OT;
function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
function byId(list, id) { for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i]; return list[0]; }
OT.money = function (n) { return '$' + n; };
function lum(h) {
var c = [1, 3, 5].map(function (i) { return parseInt(h.slice(i, i + 2), 16) / 255; })
.map(function (v) { return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
}
function ratio(x, y) { var a = lum(x), b = lum(y); return (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05); }
function verdict(r) { return r >= 3.5 ? ['Clear', 'clear'] : r >= 1.6 ? ['Soft', 'soft'] : ['Lost', 'lost']; }
var TWIN = 20;
function lab(h) {
var c = [1, 3, 5].map(function (i) { var v = parseInt(h.slice(i, i + 2), 16) / 255; return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
var f = function (t) { return t > 216 / 24389 ? Math.cbrt(t) : (24389 / 27 * t + 16) / 116; };
var x = f((c[0] * 0.4124 + c[1] * 0.3576 + c[2] * 0.1805) / 0.95047), y = f(c[0] * 0.2126 + c[1] * 0.7152 + c[2] * 0.0722),
z = f((c[0] * 0.0193 + c[1] * 0.1192 + c[2] * 0.9505) / 1.08883);
return [116 * y - 16, 500 * (x - y), 200 * (y - z)];
}
function twins(x, y) { var a = lab(x), b = lab(y); return Math.sqrt(Math.pow(a[0] - b[0], 2) + Math.pow(a[1] - b[1], 2) + Math.pow(a[2] - b[2], 2)) < TWIN; }
OT.contrast = ratio;
var toastEl, toastTimer;
OT.toast = function (msg) {
if (!toastEl) { toastEl = el('div', 'ot-toast'); toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
toastEl.innerHTML = msg; toastEl.classList.add('show');
clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 5200);
};
var BRAND = { good: ['black', 'white'], bad: ['white', 'black'], turkey: ['neon-orange', 'blue'] };
var VEC = { w: 174.94, h: 155.91, cx: 87.47, cy: 77.85, r: 73.45 };
function capList() {
var out = [];
(OT.CAP_FAMILIES || []).forEach(function (f) {
f.colors.forEach(function (c) {
out.push({ id: f.id + '-' + c.id, fam: f, color: c, name: c.name, hex: c.hex, hex2: c.hex2, image: c.image, box: c.box, onSale: c.onSale });
});
});
return out;
}
function placeCap(img, cap, isFront) {
var k = cap.color.crop;
if (!isFront || !k) { img.style.cssText = ''; return; }   // our own view photos are already square
img.style.cssText = 'left:' + (-k.x / k.s * 100) + '%;top:' + (-k.y / k.s * 100) + '%;width:' + (k.w / k.s * 100) + '%;height:' +
(k.h / k.s * 100) + '%;right:auto;bottom:auto;max-width:none;object-fit:fill';
}
function drawVector(vec, canvas, m, box, A, B) {
var turkey = m.kind === 'turkey';
var W = turkey ? box.d * 1.22 : box.d * VEC.w / (2 * VEC.r), H = W * (turkey ? 170 / 198 : VEC.h / VEC.w);
var fx = turkey ? 0.5 : VEC.cx / VEC.w, fy = turkey ? 0.53 : VEC.cy / VEC.h;
vec.style.left = (box.cx - W * fx) * 100 + '%'; vec.style.top = (box.cy - H * fy) * 100 + '%';
vec.style.width = W * 100 + '%'; vec.style.height = H * 100 + '%';
vec.style.setProperty('--a', A.hex); vec.style.setProperty('--b', B.hex);
vec.classList.toggle('is-turkey', turkey);
if (vec.dataset.mark !== m.id) { vec.querySelector('.ts-svg').innerHTML = OT.markSVG(m.id); vec.dataset.mark = m.id; }
vec.hidden = false; canvas.hidden = true;
}
function drawPhoto(canvas, vec, model, box, A, B) {
OT.threadPaint(model, canvas, A.hex, B.hex);
var s = box.d / (2 * model.e.a);   // share of the stage per photo pixel, so the stitched circle = box.d
canvas.style.width = model.w * s * 100 + '%'; canvas.style.height = model.h * s * 100 + '%';
canvas.style.left = (box.cx - model.e.cx * s) * 100 + '%'; canvas.style.top = (box.cy - model.e.cy * s) * 100 + '%';
canvas.hidden = false; vec.hidden = true;
}
OT.capStill = function (stage, o) {
var cap = byId(capList(), o.cap), m = byId(OT.MARKS, o.mark), A = byId(OT.THREADS, o.a), B = byId(OT.THREADS, o.b);
stage.classList.add('ts-stage', 'ts-still');
stage.innerHTML = '<img class="ts-cap" alt="" decoding="async"><canvas class="ts-photo" aria-hidden="true" hidden></canvas>' +
'<span class="ts-mark" hidden><span class="ts-svg"></span><i class="ts-tex"></i></span>';
var img = stage.querySelector('.ts-cap'), canvas = stage.querySelector('.ts-photo'), vec = stage.querySelector('.ts-mark');
img.alt = m.name + ' in ' + A.name + ' and ' + B.name + ' thread on a ' + cap.name + ' ' + cap.fam.name + ' cap';
if (o.rawCrop) placeCap(img, cap, true);
return new Promise(function (done) {
img.onload = img.onerror = function () { done(); };
img.src = o.capSrc ? o.capSrc(cap) : cap.image;
}).then(function () {
if (!(m.photo && OT.threadModel)) { drawVector(vec, canvas, m, cap.box, A, B); return; }
return OT.threadModel(m).then(function (model) {
if (model) drawPhoto(canvas, vec, model, cap.box, A, B); else drawVector(vec, canvas, m, cap.box, A, B);
});
});
};
OT.mountStudio = function (root, opts) {
opts = opts || {};
var T = OT.THREADS, C = capList(), M = OT.MARKS, FAM = OT.CAP_FAMILIES;
var tIndex = function (id) { for (var i = 0; i < T.length; i++) if (T[i].id === id) return i; return 0; };
function capId(id) {
var i;
for (i = 0; i < C.length; i++) if (C[i].id === id) return id;
for (i = 0; i < C.length; i++) if (C[i].color.id === id && C[i].onSale) return C[i].id;
for (i = 0; i < C.length; i++) if (C[i].color.id === id) return C[i].id;
return C[0].id;
}
function brandOf(m) { return m.kind === 'turkey' ? BRAND.turkey : BRAND[m.nature]; }
var startMark = byId(M, opts.mark || 'goodcat'), startBrand = brandOf(startMark);
var state = { cap: capId(opts.cap || 'sixpanel-white'), mark: startMark.id,
a: tIndex(opts.a || startBrand[0]), b: tIndex(opts.b || startBrand[1]), custom: !!(opts.a || opts.b), view: 'front' };
if (opts.hash) {
var h = (location.hash.match(/ts=([\w-]+\.[\w-]+\.[\w-]+\.[\w-]+)/) || [])[1];
if (h) { var p = h.split('.'); state.cap = capId(p[0]); state.mark = byId(M, p[1]).id; state.a = tIndex(p[2]); state.b = tIndex(p[3]); state.custom = true; }
}
function clash(i, j) { return i === j || (byId(M, state.mark).kind !== 'turkey' && twins(T[i].hex, T[j].hex)); }
function twoThreads() {
if (!clash(state.a, state.b)) return;
var bk = tIndex('black'), wh = tIndex('white');
state.b = ratio(T[state.a].hex, T[bk].hex) >= ratio(T[state.a].hex, T[wh].hex) ? bk : wh;
}
twoThreads();
root.classList.add('ts');
root.innerHTML =
'<div class="ts-view">' +
'<div class="ts-stage"><img class="ts-cap" alt="" width="1000" height="1000" decoding="async">' +
'<canvas class="ts-photo" aria-hidden="true" hidden></canvas>' +
'<div class="ts-mark" hidden><span class="ts-svg"></span><i class="ts-tex"></i></div>' +
'<span class="ts-live">Live preview</span></div>' +
'<div class="ts-views" role="group" aria-label="Turn the cap" hidden></div>' +
'<p class="ts-caption" aria-live="polite"></p>' +
'</div>' +
'<div class="ts-panel">' +
step(1, opts.fixed ? 'Color' : 'Cap', 'ts-v-cap',
'<div class="ts-fams" role="group" aria-label="Cap style"></div>' +
'<p class="ts-hint ts-blurb"></p>' +
'<div class="ts-capsw" role="group" aria-label="Cap color"></div>' +
'<p class="ts-stock"></p>' +
(opts.fixed ? '<p class="ts-fixed-note"></p>' : '')) +
step(2, 'Character', 'ts-v-mark', '<div class="ts-marks"></div>') +
step(3, '<span class="ts-la">Circle thread</span>', 'ts-v-a', '<div class="ts-sw" data-slot="a"></div>') +
step(4, '<span class="ts-lb">Figure thread</span>', 'ts-v-b', '<div class="ts-sw" data-slot="b"></div>') +
'<div class="ts-tools">' +
'<button type="button" class="ts-tool" data-act="swap">⇄ Swap threads</button>' +
'<button type="button" class="ts-tool" data-act="brand">Brand default</button>' +
'<button type="button" class="ts-tool" data-act="share">Copy link</button>' +
'</div>' +
'<div class="ts-checks" aria-live="polite">' +
'<div class="ts-check"><span class="ts-check-l ts-c1l"></span><strong class="ts-c1"></strong><small class="ts-c1r"></small></div>' +
'<div class="ts-check"><span class="ts-check-l ts-c2l"></span><strong class="ts-c2"></strong><small class="ts-c2r"></small></div>' +
'</div>' +
'<div class="ts-buy">' +
'<div class="ts-price"><b class="ts-amt"></b><span class="ts-ship"></span></div>' +
'<button type="button" class="ts-add" data-act="add"></button>' +
'</div>' +
'<p class="ts-final" hidden><strong>Custom threads are final sale.</strong> This cap is stitched only for you, so it can’t be returned or exchanged for a change of mind. Defects and our mistakes are always covered. <a href="' + (opts.returnsUrl || '/pages/returns-exchanges') + '">Returns policy</a></p>' +
'<p class="ts-note">Cap photos are the blank cap; the character is a photo of our real stitching, recolored. Screen colors are approximate: thread on fabric reads a little darker and glossier, and neon threads cannot show on a screen.</p>' +
'</div>';
function step(n, title, valCls, body) {
return '<section class="ts-step"><div class="ts-step-h"><span class="ts-n">' + n + '</span><h3>' + title + '</h3>' +
'<span class="ts-val ' + valCls + '"></span></div>' + body + '</section>';
}
var host = opts.stage || null;
if (host) { host.classList.add('ts', 'ts-host'); host.appendChild(root.querySelector('.ts-view')); }
if (opts.fixed) root.classList.add('ts-fixed');
var q = function (s) { return root.querySelector(s) || (host && host.querySelector(s)); };
var capOf = function (id) { return byId(C, id); };
var VIEWS = [['front', 'Front'], ['right', 'Right'], ['left', 'Left'], ['back', 'Back']];
var own = opts.own || null;
function isOwn(cap) { return !!own && cap.id === own.cap; }
var OWN_FILL = 0.82, frames = {};
function ownFrame(src) {
if (frames[src]) return frames[src];
return (frames[src] = new Promise(function (done) {
var im = new Image();
im.crossOrigin = 'anonymous';
im.onerror = function () { done(null); };
im.onload = function () {
try {
var W = 200, H = Math.round(W * im.naturalHeight / im.naturalWidth), cv = document.createElement('canvas');
cv.width = W; cv.height = H;
var g = cv.getContext('2d'); g.drawImage(im, 0, 0, W, H);
var d = g.getImageData(0, 0, W, H).data, bg = [0, 0, 0], n = 0, x, y, k;
[[0, 0], [W - 8, 0], [0, H - 8], [W - 8, H - 8]].forEach(function (c) {
for (y = c[1]; y < c[1] + 8; y++) for (x = c[0]; x < c[0] + 8; x++) { k = (y * W + x) * 4; bg[0] += d[k]; bg[1] += d[k + 1]; bg[2] += d[k + 2]; n++; }
});
bg = bg.map(function (v) { return v / n; });
var cols = new Array(W).fill(0), rows = new Array(H).fill(0);
for (y = 0; y < H; y++) for (x = 0; x < W; x++) {
k = (y * W + x) * 4;
if (Math.max(Math.abs(d[k] - bg[0]), Math.abs(d[k + 1] - bg[1]), Math.abs(d[k + 2] - bg[2])) > 14) { cols[x]++; rows[y]++; }
}
var x0 = 0, x1 = W - 1, y0 = 0, y1 = H - 1;   // a column / row counts with 2+ cap pixels (drops specks)
while (x0 < W && cols[x0] < 2) x0++;
while (x1 > 0 && cols[x1] < 2) x1--;
while (y0 < H && rows[y0] < 2) y0++;
while (y1 > 0 && rows[y1] < 2) y1--;
var bw = (x1 - x0 + 1) / W;
if (x1 <= x0 || y1 <= y0 || bw < 0.2 || bw > 0.95) { done(null); return; }
var z = OWN_FILL / bw, cx = (x0 + x1 + 1) / 2 / W, cy = (y0 + y1 + 1) / 2 / H, hr = H / W;
done({ w: z, h: z * hr, l: 0.5 - cx * z, t: 0.5 - cy * z * hr });
} catch (e) { done(null); }   // a canvas the browser won't read: show the photo as shot
};
im.src = src;
}));
}
function placeOwn(img, f) {
img.style.cssText = !f ? '' : 'left:' + f.l * 100 + '%;top:' + f.t * 100 + '%;width:' + f.w * 100 + '%;height:' + f.h * 100 +
'%;right:auto;bottom:auto;max-width:none;object-fit:fill';
}
function viewSrc(cap, v) {
if (isOwn(cap)) return own.photos[v] || null;
if (v === 'front') return opts.capSrc ? opts.capSrc(cap) : cap.image;
if (opts.viewSrc) return opts.viewSrc(cap, v);
if (opts.capSrc) return null;
return (cap.color.views && cap.color.views[v]) || null;
}
VIEWS.forEach(function (v) {
var b = el('button', 'ts-view-b', v[1]);
b.type = 'button'; b.dataset.view = v[0];
b.onclick = function () { state.view = v[0]; render(); };
b.onmouseenter = b.onfocus = function () { var u = viewSrc(capOf(state.cap), v[0]); if (u && !b.dataset.pre) { b.dataset.pre = 1; new Image().src = u; } };
q('.ts-views').appendChild(b);
});
FAM.forEach(function (f) {
var b = el('button', 'ts-fam', '<span>' + f.name + '</span>' + (f.status ? '<small class="ts-fam-tag">' + f.status + '</small>' : ''));
b.type = 'button'; b.dataset.fam = f.id;
b.onclick = function () {
if (capOf(state.cap).fam.id === f.id) return;
var cur = capOf(state.cap).color.id, pick = f.colors.filter(function (c) { return c.id === cur; })[0] || f.colors[0];
state.cap = f.id + '-' + pick.id; render();
};
q('.ts-fams').appendChild(b);
});
var mixed = C.some(function (c) { return !c.onSale; });
function buildSwatches(f) {
var wrap = q('.ts-capsw'); wrap.innerHTML = ''; wrap.dataset.fam = f.id;
f.colors.forEach(function (c) {
var mark = mixed && c.onSale;
var b = el('button', 'ts-cswatch' + (mark ? ' is-sale' : ''));
b.type = 'button'; b.dataset.cap = f.id + '-' + c.id;
b.title = c.name + (mark ? ' · in stock' : '');
b.setAttribute('aria-label', f.name + ', ' + c.name + (mark ? ', in stock' : ''));
b.style.background = c.hex2 ? 'linear-gradient(135deg,' + c.hex + ' 0 54%,' + c.hex2 + ' 54% 100%)' : c.hex;
b.onclick = function () { state.cap = b.dataset.cap; render(); };
b.onmouseenter = b.onfocus = function () { if (!b.dataset.pre) { b.dataset.pre = 1; new Image().src = opts.capSrc ? opts.capSrc(capOf(b.dataset.cap)) : c.image; } };
wrap.appendChild(b);
});
}
M.forEach(function (m) {
var thumb = m.photo ? '<span class="ts-mthumb is-photo" style="background-image:url(\'' + m.photo + '\')"></span>'
: '<span class="ts-mthumb">' + OT.markSVG(m.id, 'art') + '</span>';
var b = el('button', 'ts-opt ts-mopt' + (m.seasonal ? ' is-seasonal' : ''),
thumb + '<span class="ts-mname">' + m.name + '</span>' + (m.seasonal ? '<span class="ts-tag">Seasonal</span>' : ''));
b.type = 'button'; b.dataset.mark = m.id;
b.onclick = function () {
var was = byId(M, state.mark); state.mark = m.id; state.view = 'front';
if (!state.custom || m.kind !== was.kind) { var br = brandOf(m); state.a = tIndex(br[0]); state.b = tIndex(br[1]); state.custom = false; }
render();
};
q('.ts-marks').appendChild(b);
if (m.photo && OT.threadModel) OT.threadModel(m);   // warm the photo models in the background
});
$all('.ts-sw', root).forEach(function (wrap) {
var slot = wrap.dataset.slot;
T.forEach(function (t, i) {
var b = el('button', 'ts-swatch'); b.type = 'button'; b.style.background = t.hex;
b.title = t.name; b.setAttribute('aria-label', t.name + ' thread'); b.dataset.i = i;
b.onclick = function () {
if (clash(state[slot === 'a' ? 'b' : 'a'], i)) return;   // the other thread, or reads as it (the button is disabled too)
state[slot] = i; state.custom = true; state.view = 'front'; render();
};
wrap.appendChild(b);
});
});
root.addEventListener('click', function (e) {
var act = e.target.closest('[data-act]'); if (!act) return;
var m = byId(M, state.mark);
if (/^(swap|brand)$/.test(act.dataset.act)) state.view = 'front';
if (act.dataset.act === 'swap') { var t = state.a; state.a = state.b; state.b = t; state.custom = true; }
if (act.dataset.act === 'brand') { var br = brandOf(m); state.a = tIndex(br[0]); state.b = tIndex(br[1]); state.custom = false; }
if (act.dataset.act === 'share') {
var url = location.href.split('#')[0] + '#ts=' + key();
(navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(
function () { OT.toast('Link copied. Anyone who opens it sees this exact cap.'); },
function () { OT.toast('Share link: <code>' + url + '</code>'); });
return;
}
if (act.dataset.act === 'add') {
var s = summary(), c = capOf(state.cap);
if (clash(state.a, state.b)) { OT.toast('Pick two threads that stand apart: the figure would disappear into the circle.'); return; }
if (opts.cart && c.onSale) { addToCart(c, s, act); return; }
if (c.onSale) {
OT.toast('<b>Preview only.</b> On Shopify this adds one ' + s.cap + ' cap to the cart, with the order notes: ' +
'Character: ' + s.mark + ' · ' + s.la + ': ' + s.a + ' · ' + s.lb + ': ' + s.b + '.');
} else {
OT.toast('<b>Preview only.</b> ' + s.cap + ' is not stocked yet, so on Shopify this button signs the visitor up ' +
'to hear when it is (customer tag <code>studio-' + c.id + '</code>). Nothing was sent.');
}
return;
}
render();
});
function addToCart(c, s, btn) {
if (isOwn(c)) { post([{ id: own.variant, quantity: 1 }], btn); return; }   // the product itself, as its own form would
if (!(opts.cart.variants || []).length) { OT.toast('Ordering from the Studio opens soon. To order this cap now, write to ' + OT.SITE.email + '.'); return; }
var v = (opts.cart.variants || []).filter(function (x) { return x.style === c.fam.name && x.color === c.name; })[0];
if (!v) { OT.toast('This cap isn’t set up for the Studio yet. Pick another color, or write to ' + OT.SITE.email + '.'); return; }
if (v.available === false) { OT.toast(s.cap + ' is sold out right now.'); return; }
var props = { Character: s.mark };
props[s.la] = s.a; props[s.lb] = s.b;
if (customThreads()) props.Returns = 'Final sale (custom threads)';
post([{ id: v.id, quantity: 1, properties: props }], btn);
}
function post(items, btn) {
btn.disabled = true;
fetch(opts.cart.addUrl || '/cart/add.js', {
method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify({ items: items })
}).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (res) {
btn.disabled = false;
if (!res.ok) { OT.toast((res.j && (res.j.description || res.j.message)) || 'Could not add to the cart.'); return; }
window.location.href = opts.cart.cartUrl || '/cart';
}).catch(function () { btn.disabled = false; OT.toast('Could not reach the cart. Please try again.'); });
}
function customThreads() { var br = brandOf(byId(M, state.mark)); return T[state.a].id !== br[0] || T[state.b].id !== br[1]; }
function key() { return state.cap + '.' + state.mark + '.' + T[state.a].id + '.' + T[state.b].id; }
function summary() {
var m = byId(M, state.mark), turkey = m.kind === 'turkey', c = capOf(state.cap);
return { cap: c.name + ' ' + c.fam.name, mark: m.name, a: T[state.a].name, b: T[state.b].name,
la: turkey ? 'Feather thread 1' : 'Circle thread', lb: turkey ? 'Feather thread 2' : 'Figure thread' };
}
var canvas = q('.ts-photo'), vec = q('.ts-mark'), token = 0, ready = {};
function cropCap(img, cap, isFront) { if (opts.rawCrop) placeCap(img, cap, isFront); }
function showVector(m, box, A, B) { drawVector(vec, canvas, m, box, A, B); }
function showPhoto(model, box, A, B) { drawPhoto(canvas, vec, model, box, A, B); }
function render() {
var cap = capOf(state.cap), f = cap.fam, m = byId(M, state.mark), A = T[state.a], B = T[state.b], turkey = m.kind === 'turkey';
var img = q('.ts-cap'), view = state.view;
if (view !== 'front' && !viewSrc(cap, view)) view = state.view = 'front';   // this cap has no such photo
var src = viewSrc(cap, view), turned = view !== 'front', mine = isOwn(cap);
if (img.dataset.want !== src) {
img.dataset.want = src;
var show = function () {
if (img.dataset.want !== src) return;
if (mine) { ownFrame(src).then(function (f) { if (img.dataset.want === src) { img.src = src; placeOwn(img, f); } }); return; }
img.src = src; img.style.cssText = ''; cropCap(img, cap, !turned);
};
if (!img.getAttribute('src')) show();
else { var pre = new Image(); pre.onload = pre.onerror = show; pre.src = src; }
}
q('.ts-stage').classList.toggle('is-own', mine);
if (turned || mine) { token++; canvas.hidden = true; vec.hidden = true; }
else if (m.photo && OT.threadModel) {
var tok = ++token;
if (!ready[m.id]) showVector(m, cap.box, A, B);   // first load only: vector art until the photo is read
OT.threadModel(m).then(function (model) {
if (tok !== token) return;                      // a newer choice has been made since
if (model) { ready[m.id] = true; showPhoto(model, cap.box, A, B); }
else showVector(m, cap.box, A, B);
});
} else { token++; showVector(m, cap.box, A, B); }
var s = summary();
var vname = byId(VIEWS.map(function (v) { return { id: v[0], name: v[1] }; }), view).name;
img.alt = mine && own.alts && own.alts[view] ? own.alts[view]
: turned ? s.cap + ' cap, ' + vname.toLowerCase() + ' view' : s.mark + ' in ' + s.a + ' and ' + s.b + ' thread on a ' + s.cap + ' cap';
q('.ts-caption').textContent = turned ? s.cap + ' · ' + vname + ' view' : s.mark + ' · ' + s.a + ' + ' + s.b + ' on ' + s.cap;
q('.ts-stage').classList.toggle('is-turned', turned);
var avail = VIEWS.filter(function (v) { return viewSrc(cap, v[0]); }).length > 1;
q('.ts-views').hidden = !avail;
$all('.ts-view-b', host || root).forEach(function (b) {
b.hidden = !viewSrc(cap, b.dataset.view);
b.setAttribute('aria-pressed', String(b.dataset.view === view));
});
q('.ts-la').textContent = s.la; q('.ts-lb').textContent = s.lb;
q('.ts-v-cap').innerHTML = '<i style="background:' + cap.hex + '"></i>' + f.name + ' · ' + cap.name;
q('.ts-v-mark').textContent = m.name + (m.seasonal ? ' · Wave 2' : '');
q('.ts-v-a').innerHTML = '<i style="background:' + A.hex + '"></i>' + A.name;
q('.ts-v-b').innerHTML = '<i style="background:' + B.hex + '"></i>' + B.name;
if (q('.ts-capsw').dataset.fam !== f.id) buildSwatches(f);
q('.ts-blurb').textContent = f.blurb + '. ' + f.colors.length + (f.colors.length === 1 ? ' color.' : ' colors.');
var inStock = f.colors.filter(function (c) { return c.onSale; }).map(function (c) { return c.name; });
q('.ts-stock').innerHTML = mine && !own.available ? '<i></i><span>Sold out</span>' : cap.onSale
? '<i class="is-in"></i><span>In stock · made to order in Austin, ships in ' + OT.SITE.makeDays + ' business days</span>'
: '<i></i><span>Not stocked yet, so this one is a preview.' +
(inStock.length ? ' In stock now: ' + inStock.join(', ') + '.' : f.status ? ' ' + f.name + ': ' + f.status.toLowerCase() + '.' : '') + '</span>';
var price = mine && own.price ? own.price : f.price;
q('.ts-amt').textContent = price ? OT.money(price) : 'Price soon';
q('.ts-ship').textContent = cap.onSale ? '$' + OT.SITE.pairOff + ' off two or more caps · ' + (f.price === OT.SITE.price ? 'two come to $' + OT.SITE.pair + ', shipped free' : 'free shipping from $' + OT.SITE.freeOver)
: f.price ? 'Planned price · this color is not stocked yet' : 'We’ll set the price before this cap goes on sale';
var soldOut = mine && !own.available;
q('.ts-add').textContent = soldOut ? 'Sold out' : cap.onSale ? (opts.buyLabel || 'Add to cart') : 'Tell me when it’s in';
q('.ts-add').classList.toggle('is-notify', !cap.onSale);
q('.ts-add').disabled = soldOut;
q('.ts-final').hidden = mine || !cap.onSale || !customThreads();
q('.ts-note').hidden = mine;   // it explains the drawn preview; the product's photos are of the cap itself
$all('[data-fam]', root).forEach(function (e) { e.setAttribute('aria-pressed', String(e.dataset.fam === f.id)); });
$all('[data-cap]', root).forEach(function (e) { e.setAttribute('aria-pressed', String(e.dataset.cap === state.cap)); });
$all('[data-mark]', root).forEach(function (e) { e.setAttribute('aria-pressed', String(e.dataset.mark === state.mark)); });
$all('.ts-sw', root).forEach(function (w) {
var slot = w.dataset.slot, cur = state[slot], other = state[slot === 'a' ? 'b' : 'a'];
$all('.ts-swatch', w).forEach(function (e) {
var i = +e.dataset.i, taken = clash(other, i), t = T[i], why = (i === other ? 'already the ' : 'too close to the ') + (slot === 'a' ? s.lb : s.la).toLowerCase();
e.setAttribute('aria-pressed', String(+e.dataset.i === cur));
e.disabled = taken; e.classList.toggle('is-taken', taken);
e.title = taken ? t.name + ' · ' + why : t.name;
e.setAttribute('aria-label', t.name + ' thread' + (taken ? ', not available: ' + why : ''));
});
});
var r1, r2, l1, l2;
if (turkey) { r1 = ratio(A.hex, B.hex); r2 = Math.max(ratio(A.hex, cap.hex), ratio(B.hex, cap.hex)); l1 = 'Feather 1 vs feather 2'; l2 = 'Tail on the cap'; }
else { r1 = ratio(A.hex, cap.hex); r2 = ratio(A.hex, B.hex); l1 = 'Circle edge on cap'; l2 = 'Figure inside circle'; }
setCheck('.ts-c1', l1, r1); setCheck('.ts-c2', l2, r2);
if (opts.hash && !first && history.replaceState) history.replaceState(null, '', '#ts=' + key());
first = false;
if (opts.fixed) q('.ts-fixed-note').innerHTML = s.mark + ' in its own threads: ' + s.a + ' circle, ' + s.b + ' figure. ' +
'<a href="' + (opts.studioUrl || '/') + '#ts=' + key() + '">Pick other threads in the Thread Studio</a>';
if (opts.onChange) opts.onChange(s, state);
}
var first = true;
function setCheck(sel, label, r) {
var v = verdict(r); q(sel + 'l').textContent = label;
var s = q(sel); s.textContent = v[0]; s.className = sel.slice(1) + ' is-' + v[1];
q(sel + 'r').textContent = r.toFixed(1) + ':1 contrast';
}
render();
function set(k) { var p = k.split('.'); state.cap = capId(p[0]); state.mark = byId(M, p[1]).id; state.a = tIndex(p[2]); state.b = tIndex(p[3]); state.custom = true; twoThreads(); render(); }
document.addEventListener('click', function (e) {
var l = e.target.closest('[data-studio]'); if (!l) return;
set(l.dataset.studio);
});
return { state: state, render: render, set: set };
};
(function () {
var n = { styles: (OT.CAP_FAMILIES || []).length, colors: capList().length, characters: (OT.MARKS || []).length, threads: (OT.THREADS || []).length };
$all('[data-ot-count]').forEach(function (e) { if (n[e.dataset.otCount] != null) e.textContent = n[e.dataset.otCount] + (e.dataset.otSuffix || ''); });
})();
var CHECK = '<svg class="rv-check" viewBox="0 0 20 20" aria-label="Verified buyer"><circle cx="10" cy="10" r="10"/><path d="M5.5 10.4l3 3 6-6.6" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
OT.mountReviews = function (root, opts) {
opts = opts || {};
var items = opts.items || OT.REVIEWS || [];
var initial = opts.initial || 6, stepN = opts.step || 6, shown = 0;
var grid = el('div', 'rv-grid'), more = el('button', 'rv-more', opts.moreLabel || 'Show more happy customers');
more.type = 'button';
root.classList.add('rv'); root.appendChild(grid);
var foot = el('div', 'rv-foot'); foot.appendChild(more); root.appendChild(foot);
function photoFor(r) {
if (r.photo) return r.photo;
for (var i = 0; i < OT.PRODUCTS.length; i++) if (OT.PRODUCTS[i].handle === r.photoProduct) return OT.img(OT.PRODUCTS[i].img, 600);
return '';
}
function card(r) {
var a = el('article', 'rv-card');
a.innerHTML =
'<div class="rv-photo"><img loading="lazy" src="' + photoFor(r) + '" alt="' + (r.photo ? 'Customer photo: ' : 'Product photo: ') + r.product + '">' +
'<span class="rv-product">' + r.product + '</span>' +
(r.repeat ? '<span class="rv-ribbon"><span>' + (opts.ribbon || 'Repeat customer') + '</span></span>' : '') + '</div>' +
'<div class="rv-body">' +
'<div class="rv-stars" role="img" aria-label="' + r.stars + ' out of 5 stars">' + '★★★★★'.slice(0, r.stars) + '<span class="rv-off">' + '★★★★★'.slice(r.stars) + '</span></div>' +
'<h3 class="rv-name">' + r.name + CHECK + '</h3>' +
'<p class="rv-meta">' + (r.loc ? r.loc + ' · ' : '') + r.date + '</p>' +
'<p class="rv-text">' + r.text + '</p>' +
'</div>';
return a;
}
function showMore(n) {
items.slice(shown, shown + n).forEach(function (r) { grid.appendChild(card(r)); });
shown = Math.min(items.length, shown + n);
root.classList.toggle('is-all', shown >= items.length);
if (shown >= items.length) more.textContent = opts.doneLabel || 'You’re all caught up';
more.disabled = shown >= items.length;
}
more.onclick = function () { showMore(stepN); };
showMore(initial);
foot.hidden = items.length <= initial;   // nothing more to show: no button
};
OT.renderProducts = function (root, filter, template) {
root.innerHTML = OT.PRODUCTS.filter(filter).map(template).join('');
};
OT.countdown = function (root, iso) {
var end = new Date(iso).getTime();
function pad(n) { return (n < 10 ? '0' : '') + n; }
function tick() {
var d = Math.max(0, end - Date.now()), s = Math.floor(d / 1000);
var parts = { d: Math.floor(s / 86400), h: pad(Math.floor(s % 86400 / 3600)), m: pad(Math.floor(s % 3600 / 60)), s: pad(s % 60) };
$all('[data-cd]', root).forEach(function (e) { e.textContent = parts[e.dataset.cd]; });
}
tick(); setInterval(tick, 1000);
};
OT.renderFAQ = function (root) {
root.innerHTML = OT.FAQ.map(function (f) { return '<details class="faq-i"><summary>' + f.q + '</summary><p>' + f.a + '</p></details>'; }).join('');
};
document.addEventListener('submit', function (e) {
var f = e.target; if (!f.matches('[data-preview-form]')) return;
e.preventDefault();
OT.toast('<b>Preview only.</b> On Shopify this is the native customer sign-up form' + (f.dataset.previewForm ? ', tagged <code>' + f.dataset.previewForm + '</code>' : '') + '. Nothing was sent.');
});
document.addEventListener('click', function (e) {
var t = e.target.closest('[data-nav-toggle]');
if (t) { var open = document.body.classList.toggle('nav-open'); t.setAttribute('aria-expanded', String(open)); return; }
if (e.target.closest('.site-nav a')) document.body.classList.remove('nav-open');
var cart = e.target.closest('[data-preview-cart]');
if (cart) { e.preventDefault(); OT.toast('<b>Preview only.</b> On Shopify this goes to ' + cart.dataset.previewCart + '.'); }
});
OT.tabs = function (root, onPick) {
$all('[data-tab]', root).forEach(function (b) {
b.addEventListener('click', function () {
$all('[data-tab]', root).forEach(function (x) { x.setAttribute('aria-selected', String(x === b)); });
onPick(b.dataset.tab);
});
});
};
if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
var io = new IntersectionObserver(function (es) { es.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
document.addEventListener('DOMContentLoaded', function () { $all('[data-reveal]').forEach(function (n) { io.observe(n); }); });
} else {
document.addEventListener('DOMContentLoaded', function () { $all('[data-reveal]').forEach(function (n) { n.classList.add('in'); }); });
}
})();
;
/* Shopify glue */
(function () {
var OT = window.OT;
function each(sel, root, fn) {
var list = Array.prototype.slice.call((root || document).querySelectorAll(sel));
if (root && root.matches && root.matches(sel)) list.unshift(root);
list.forEach(fn);
}
function once(el, key) { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; }
function studio(root) {
each('[data-ot1-studio]', root, function (sec) {
if (!once(sec, 'ot1Ready')) return;
var cfgEl = sec.querySelector('script[type="application/json"]'), cfg = {};
try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {}
OT.MARKS.forEach(function (m) { if (m.kind === 'circle') m.photo = (cfg.photos || {})[m.id] || null; });
var hw = document.documentElement.classList.contains('ot-hw');
OT.mountStudio(sec.querySelector('.ot1-ts'), {
hash: true, cap: (hw && cfg.hwCap) || cfg.cap, mark: (hw && cfg.hwMark) || cfg.mark, buyLabel: cfg.buyLabel || 'Add to cart', rawCrop: true,
capSrc: function (cap) { return cfg.capBase + 'ot-studio-cap-' + cap.id + '.jpg'; },
viewSrc: function (cap, v) { return cap.color.views && cap.color.views[v] ? cfg.capBase + 'ot-studio-view-' + cap.id + '-' + v + '.jpg' : null; },
cart: { variants: cfg.variants || [], addUrl: cfg.addUrl, cartUrl: cfg.cartUrl }
});
if (/^#ts=/.test(location.hash)) {
var go = function () { sec.scrollIntoView({ behavior: 'instant', block: 'start' }); };
if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
}
});
}
function countdowns(root) {
each('[data-ot1-countdown]', root, function (el) { if (once(el, 'ot1Ready')) OT.countdown(el, el.getAttribute('data-ot1-countdown')); });
}
function marks(root) {
each('[data-ot1-mark]', root, function (el) {
if (!once(el, 'ot1Ready')) return;
el.innerHTML = OT.markSVG(el.getAttribute('data-ot1-mark'), el.getAttribute('data-palette') || undefined) || '';
if (el.dataset.a) el.style.setProperty('--a', el.dataset.a);
if (el.dataset.b) el.style.setProperty('--b', el.dataset.b);
});
}
function lineups(root) {
each('[data-ot1-lineup]', root, function (sec) {
if (!once(sec, 'ot1Ready')) return;
var grid = sec.querySelector('.ot1-grid4'), MARK = {};
(OT.MARKS || []).forEach(function (m) { MARK[m.id] = m; });
Array.prototype.forEach.call(sec.querySelectorAll('[data-studio-style]'), function (t) {
var fam = (OT.CAP_FAMILIES || []).filter(function (f) { return f.name === t.getAttribute('data-studio-style'); })[0];
if (!fam || !grid) return;
fam.colors.forEach(function (c) {
var id = fam.id + '-' + c.id, m = MARK[(OT.STITCHED || {})[id]], src = (OT.STITCHED_CDN || {})[id];
if (!m || !src) return;
var href = '/products/' + m.id.replace(/^(good|bad)/, '$1-') + '?build=' + fam.id + '&color=' + c.id;
var d = document.createElement('div');
d.className = 'ot1-pc'; d.hidden = true; d.setAttribute('data-tags', fam.name);
d.innerHTML = '<div class="ot1-pc-img"><a class="ot1-pc-link" href="' + href + '">' +
'<img loading="lazy" src="' + src + '&width=800" alt="' + m.name + ' on a ' + c.name + ' ' + fam.name + ' cap"></a>' +
'<span class="ot1-pc-nature ' + m.nature + '">' + (m.nature === 'good' ? 'Good' : 'Bad') + '</span></div>' +
'<a class="ot1-pc-info" href="' + href + '">' +
'<div class="ot1-pc-row"><h3>' + c.name + '</h3><span class="ot1-pc-price">$' + fam.price + '</span></div>' +
'<p class="ot1-pc-tag">Shown with ' + m.name + '</p></a>';
grid.appendChild(d);
});
});
var tabs = sec.querySelectorAll('[data-tab]'), cards = sec.querySelectorAll('.ot1-pc');
function pick(tag) {
Array.prototype.forEach.call(tabs, function (t) { t.setAttribute('aria-selected', String(t.getAttribute('data-tab') === tag)); });
Array.prototype.forEach.call(cards, function (c) { c.hidden = ('|' + c.getAttribute('data-tags') + '|').indexOf('|' + tag + '|') < 0; });
}
Array.prototype.forEach.call(tabs, function (t) { t.addEventListener('click', function () { pick(t.getAttribute('data-tab')); }); });
});
}
var FIT = {
sixpanel: { closure: 'adjustable hook-and-loop strap', hat: '7–7 5/8', head: '22–23 7/8 in (56–61 cm)', bill: '2 3/4', crown: '6 5/8', front: '3 3/4' },
trucker: { closure: 'snapback closure, stretch sweatband', hat: '6 1/2–7 7/8', head: '20 3/8–24 5/8 in (52–63 cm)', bill: '2 5/8', crown: '6 7/8', front: '7 1/2' },
washed: { closure: 'fabric strap with a metal D-ring slider', hat: '6 5/8–8', head: '20 7/8–25 1/8 in (53–64 cm)', bill: '2 7/8', crown: '6 1/2', front: '7 3/8',
note: 'The distressing and the color vary a little from cap to cap.' },
fivepanel: { closure: 'soft adjustable snap strap', hat: '7–7 3/4', head: '22–24 1/4 in (56–62 cm)', bill: '2 3/4', crown: '6 5/8', front: '7 1/4' }
};
function fitHTML(x) {
return '<p><strong>One size fits all</strong> — ' + x.closure + '.</p><ul><li>Hat size: ' + x.hat + '</li><li>Head circumference: ' + x.head +
'</li><li>Bill length: ' + x.bill + ' in</li><li>Crown height: ' + x.crown + ' in</li><li>Front panel width: ' + x.front + ' in</li></ul>' +
(x.note ? '<p>' + x.note + '</p>' : '') + '<p>To measure: wrap a tape around your head just above the eyebrows, at the widest point.</p>';
}
var ABOUT = {
washed: 'A washed cap: unstructured, distressed cotton twill, low profile, metal D-ring strap, embroidered in-house in Austin.',
fivepanel: 'A two-tone five-panel cap: unstructured cotton twill, precurved bill, snap closure, embroidered in-house in Austin.'
};
var usd = function (n) { return '$' + n.toFixed(2); };
function moreBuilds(root) {
each('[data-ot1-builds]', root, function (box) {
if (!once(box, 'ot1Ready')) return;
var sec = box.closest('.shopify-section') || document.body;
function giveUp() { sec.classList.remove('ot1-alt', 'ot1-wait'); }
var cfg = {}, ownCfg = null;
try {
cfg = JSON.parse(box.querySelector('script[type="application/json"]:not([data-ot1-own])').textContent);
var oj = box.querySelector('script[data-ot1-own]'); if (oj) ownCfg = JSON.parse(oj.textContent);
} catch (e) { giveUp(); return; }
var famBy = function (n) { return (OT.CAP_FAMILIES || []).filter(function (f) { return f.name === n; })[0]; };
var mark = (OT.MARKS || []).filter(function (m) { return m.id === cfg.mark; })[0];
var fams = (cfg.styles || []).map(famBy).filter(Boolean);
var row = Array.prototype.filter.call(sec.querySelectorAll('.ot-sw'), function (fs) { return /build/i.test((fs.querySelector('legend') || {}).textContent || ''); })[0];
if (!mark || !fams.length || !row) { giveUp(); return; }
var native = ownCfg && famBy(ownCfg.style), ownCol = native && native.colors.filter(function (c) { return c.name === ownCfg.color; })[0];
if (!ownCol) { native = null; giveUp(); }
var own = native ? { cap: native.id + '-' + ownCol.id, photos: ownCfg.photos, alts: ownCfg.alts, variant: ownCfg.variant,
available: ownCfg.available, price: ownCfg.price } : null;
OT.MARKS.forEach(function (m) { if (m.kind === 'circle') m.photo = (cfg.photos || {})[m.id] || null; });
var opts = row.querySelector('.ot-sw__opts'), cur = row.querySelector('.ot-sw__current'), curText = cur ? cur.textContent : '';
var h1 = sec.querySelector('.product-details h1'), h1Text = h1 ? h1.textContent : '';
var media = sec.querySelector('.product-information__media'), panel = box.querySelector('.ot1-mb-panel');
var ownOpt = opts.querySelector('.is-active'), ownLink = document.createElement('a');
if (ownOpt) { ownLink.className = ownOpt.className; ownLink.href = location.pathname; ownLink.innerHTML = ownOpt.innerHTML; ownOpt.parentNode.replaceChild(ownLink, ownOpt); }
fams.forEach(function (f) {
var a = document.createElement('a');
a.className = 'ot-sw__opt'; a.href = '?build=' + f.id; a.setAttribute('data-ot1-build', f.id);
a.innerHTML = '<span class="ot-sw__text">' + f.name + '</span>';
opts.appendChild(a);
});
var stage = document.createElement('div'); stage.className = 'ot1 ot1-mb-stage';
if (media) media.insertBefore(stage, media.firstChild);
var others = Array.prototype.filter.call(sec.querySelectorAll('.ot-sw a.ot-sw__opt'), function (a) { return !row.contains(a); });
others.forEach(function (a) { a.setAttribute('data-base', a.getAttribute('href').split('?')[0]); });
var api = null, fam = null;
var pairBox = sec.querySelector('.ot-pair-offer'), pairAlt = null, pairItem = null;
var descEl = sec.querySelector('[class*="text_aEtTtq"]'), descOwn = descEl ? descEl.innerHTML : '';
var fitEl = sec.querySelector('[class*="text_size_fit_ot"]'), fitOwn = fitEl ? fitEl.innerHTML : '';
var natureP = descEl && Array.prototype.filter.call(descEl.querySelectorAll('p'), function (p) { return /^One of two natures/.test(p.textContent.trim()); })[0];
var twin = OT.MARKS.filter(function (m) {
return m.kind === mark.kind && m.nature !== mark.nature && m.id.replace(/^(good|bad)/, '') === mark.id.replace(/^(good|bad)/, '');
})[0];
var tname = function (id) { return (OT.THREADS.filter(function (t) { return t.id === id; })[0] || {}).name; };
function addTwin(e) {
var btn = e.currentTarget;
if (!pairItem || btn.disabled) return;
btn.disabled = true; btn.textContent = 'Adding…';
fetch(cfg.addUrl || '/cart/add.js', {
method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [pairItem] })
}).then(function (r) {
if (!r.ok) throw new Error('add failed');
btn.textContent = 'Added — opening cart…'; window.location.href = cfg.cartUrl || '/cart';
}).catch(function () { btn.disabled = false; btn.textContent = 'Add ' + twin.name; OT.toast('Could not add to the cart. Please try again.'); });
}
function retell(colour) {
var made = !!fam && fam !== native, c = fam && fam.colors.filter(function (x) { return x.id === colour; })[0];
if (fitEl) fitEl.innerHTML = fam && FIT[fam.id] ? fitHTML(FIT[fam.id]) : fitOwn;
if (descEl) descEl.innerHTML = !made || !ABOUT[fam.id] ? descOwn : '<p>' + ABOUT[fam.id] + ' The mark is rendered in dense satin stitch — flat, bold, deliberate.</p>' +
(natureP ? natureP.outerHTML : '') + '<p><strong>The Pair — $' + OT.SITE.pairOff + ' off when you buy two or more caps.</strong> Mix any styles and colors; it comes off ' +
'automatically at checkout. Free shipping from $' + OT.SITE.freeOver + '.</p>';
if (pairBox) pairBox.hidden = made;
var v = made && c && twin && pairBox && (cfg.variants || []).filter(function (x) { return x.style === fam.name && x.color === c.name; })[0];
if (!v || v.available === false) { if (pairAlt) pairAlt.hidden = true; return; }
if (!pairAlt) {
pairAlt = pairBox.cloneNode(true);
pairAlt.removeAttribute('data-shopify-editor-block');
pairBox.parentNode.insertBefore(pairAlt, pairBox.nextSibling);
pairAlt.querySelector('.ot-pair-offer__btn').addEventListener('click', addTwin);
}
var A = twin.nature === 'good' ? 'black' : 'white', B = twin.nature === 'good' ? 'white' : 'black', total = fam.price * 2 - OT.SITE.pairOff;
pairItem = { id: v.id, quantity: 1, properties: { Character: twin.name, 'Circle thread': tname(A), 'Figure thread': tname(B) } };
var key = fam.id + '-' + c.id, img = pairAlt.querySelector('.ot-pair-offer__img');
if (img.getAttribute('data-cap') !== key) {
img.setAttribute('data-cap', key);
img.innerHTML = '<span></span>';
OT.capStill(img.firstChild, { cap: key, mark: twin.id, a: A, b: B, rawCrop: true,
capSrc: function (cap) { return cfg.capBase + 'ot-studio-cap-' + cap.id + '.jpg'; } });
}
pairAlt.querySelector('.ot-pair-offer__title').textContent = twin.name + ' — ' + fam.name + ' · ' + c.name + ' · ' + usd(fam.price);
pairAlt.querySelector('.ot-pair-offer__copy').innerHTML = 'Add it — <strong>the pair is ' + usd(total) + '</strong>' +
(total >= OT.SITE.freeOver ? ', free shipping included.' : '.');
var btn = pairAlt.querySelector('.ot-pair-offer__btn');
if (!btn.disabled) btn.textContent = 'Add ' + twin.name;
pairAlt.hidden = false;
}
function sync() {
var colour = fam && api ? api.state.cap.slice(fam.id.length + 1) : '';
var q = !colour || (fam === native && colour === ownCol.id) ? '' : '?build=' + fam.id + '&color=' + colour;
if (history.replaceState) history.replaceState(null, '', location.pathname + q);
others.forEach(function (a) { a.href = a.getAttribute('data-base') + q; });
retell(colour);
}
function show(f, colour) {
if (!f && native) { f = native; colour = colour || ownCol.id; }
fam = f;
sec.classList.toggle('ot1-alt', !!f); panel.hidden = !f;
if (ownOpt) {
var home = !f || f === native;
ownLink.classList.toggle('is-active', home);
if (home) ownLink.setAttribute('aria-current', 'true'); else ownLink.removeAttribute('aria-current');
}
Array.prototype.forEach.call(opts.querySelectorAll('[data-ot1-build]'), function (a) {
var on = !!f && a.getAttribute('data-ot1-build') === f.id;
a.classList.toggle('is-active', on); if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
});
if (cur) cur.textContent = f ? f.name : curText;
if (h1) h1.textContent = f ? (cfg.title || '[character] — [style]').replace('[character]', mark.name).replace('[style]', f.name) : h1Text;
if (f) {
var c = f.colors.filter(function (x) { return x.id === colour; })[0] || (f === native ? ownCol : f.colors[0]);
if (!api) {
api = OT.mountStudio(panel, {
cap: f.id + '-' + c.id, mark: mark.id, fixed: true, stage: stage, rawCrop: true, studioUrl: cfg.studioUrl, own: own,
capSrc: function (cap) { return cfg.capBase + 'ot-studio-cap-' + cap.id + '.jpg'; },
viewSrc: function (cap, v) { return cap.color.views && cap.color.views[v] ? cfg.capBase + 'ot-studio-view-' + cap.id + '-' + v + '.jpg' : null; },
cart: { variants: cfg.variants || [], addUrl: cfg.addUrl, cartUrl: cfg.cartUrl },
onChange: function () { if (fam) sync(); }
});
} else {
api.set(f.id + '-' + c.id + '.' + mark.id + '.' + (mark.nature === 'good' ? 'black.white' : 'white.black'));
}
}
sync();
}
opts.addEventListener('click', function (e) {
var a = e.target.closest('a'); if (!a) return;
var id = a.getAttribute('data-ot1-build');
if (id) { e.preventDefault(); show(fams.filter(function (f) { return f.id === id; })[0]); }
else if (a === ownLink && (fam || native)) { e.preventDefault(); show(null); }
});
var p = new URLSearchParams(location.search), all = native ? [native].concat(fams) : fams;
var start = all.filter(function (f) { return f.id === p.get('build'); })[0] || native;
try { if (start) show(start, p.get('color')); }
catch (e) { stage.remove(); panel.hidden = true; giveUp(); throw e; }
sec.classList.remove('ot1-wait');
});
}
function reviews(root) {
each('[data-ot1-reviews]', root, function (sec) {
if (!once(sec, 'ot1Ready')) return;
var wall = sec.querySelector('.rv'), more = sec.querySelector('.rv-more'), cards = sec.querySelectorAll('.rv-card');
var shown = 0, first = +sec.getAttribute('data-initial') || 8, step = +sec.getAttribute('data-step') || 4;
function show(n) {
shown = Math.min(cards.length, shown + n);
Array.prototype.forEach.call(cards, function (c, i) { c.hidden = i >= shown; });
var all = shown >= cards.length;
wall.classList.toggle('is-all', all);
if (more) { more.disabled = all; if (all) more.textContent = more.getAttribute('data-done') || 'You’re all caught up'; }
}
if (more) more.addEventListener('click', function () { show(step); });
shown = 0; show(first);
});
}
function capCards(root) {
var byId = {};
(OT.CAP_FAMILIES || []).forEach(function (f) { f.colors.forEach(function (c) { byId[f.id + '-' + c.id] = { f: f, c: c }; }); });
each('[data-ot1-capimg]', root, function (cell) {
if (!once(cell, 'ot1Ready')) return;
var hit = byId[cell.getAttribute('data-ot1-capimg')]; if (!hit) return;
var k = hit.c.crop, img = new Image();
img.alt = hit.c.name + ' ' + hit.f.name.toLowerCase() + ' cap'; img.loading = 'lazy';
img.src = cell.getAttribute('data-base') + 'ot-studio-cap-' + hit.f.id + '-' + hit.c.id + '.jpg';
img.style.cssText = 'height:' + (k.h / k.s * 100) + '%;width:auto;top:' + (-k.y / k.s * 100) + '%;left:50%;transform:translateX(-' + ((k.x + k.s / 2) / k.w * 100) + '%)';
cell.appendChild(img);
});
each('[data-ot1-chips]', root, function (box) {
if (!once(box, 'ot1Ready')) return;
var f = (OT.CAP_FAMILIES || []).filter(function (x) { return x.id === box.getAttribute('data-ot1-chips'); })[0];
if (f) box.innerHTML = f.colors.map(function (c) { return '<span><i style="background:' + c.hex + '"></i>' + c.name + '</span>'; }).join('');
});
}
var CART_SEL = 'a.cart-items__media-container[href*="/products/"]:not([data-ot1-still])';
function named(list, name) { for (var i = 0; i < list.length; i++) if (list[i].name === name) return list[i]; return null; }
function cartThumbs(root) {
var links = Array.prototype.slice.call((root || document).querySelectorAll(CART_SEL));
if (!links.length) return;
var cfg = {};
try { cfg = JSON.parse(document.getElementById('ot1-cart-cfg').textContent); } catch (e) { return; }
links.forEach(function (a) { a.setAttribute('data-ot1-still', 'wait'); });
OT.MARKS.forEach(function (m) { if (m.kind === 'circle') m.photo = (cfg.photos || {})[m.id] || null; });   // the same photos as the Studio
fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
.then(function (r) { return r.json(); }).then(function (cart) {
var byKey = {};
(cart.items || []).forEach(function (it) { byKey[it.key] = it; });
function draw(a, capId, m, A, B) {
var box = document.createElement('span'), still = document.createElement('span');
box.className = 'ot1-cthumb';
box.appendChild(still);
a.appendChild(box);
OT.capStill(still, { cap: capId, mark: m, a: A, b: B, rawCrop: true,
capSrc: function (cap) { return cfg.capBase + 'ot-studio-cap-' + cap.id + '.jpg'; } })
.then(function () { a.setAttribute('data-ot1-still', 'done'); });
}
links.forEach(function (a) {
var row = a.closest('[data-key]'), it = row && byKey[row.getAttribute('data-key')], p = (it && it.properties) || {};
var own = it && it.handle !== 'thread-studio-cap' && (cfg.own || {})[it.handle];
if (own) { draw(a, own.cap, own.mark, own.a, own.b); return; }
if (!it || it.handle !== 'thread-studio-cap' || !p.Character) { a.setAttribute('data-ot1-still', 'none'); return; }
var opt = {};
(it.options_with_values || []).forEach(function (o) { opt[o.name] = o.value; });
var fam = named(OT.CAP_FAMILIES || [], opt.Style), col = fam && named(fam.colors, opt.Color), m = named(OT.MARKS, p.Character),
A = named(OT.THREADS, p['Circle thread'] || p['Feather thread 1']), B = named(OT.THREADS, p['Figure thread'] || p['Feather thread 2']);
if (!col || !m || !A || !B) { a.setAttribute('data-ot1-still', 'none'); return; }
var capId = fam.id + '-' + col.id;
draw(a, capId, m.id, A.id, B.id);
var studio = (cfg.studioUrl || '/') + '#ts=' + [capId, m.id, A.id, B.id].join('.');
a.href = studio;
var title = row.querySelector('a.cart-items__title');
if (title) title.href = studio;
});
}).catch(function () { links.forEach(function (a) { a.setAttribute('data-ot1-still', 'none'); }); });
}
OT.cartThumbs = cartThumbs;
var VEC = { w: 174.94, h: 155.91, cx: 87.47, cy: 77.85, r: 73.45 };   // the circle in the vector marks' viewBox, as in ot-core.js
function gridStills(root) {
each('[data-ot1-gcfg]', root, function (cfgEl) {
if (!once(cfgEl, 'ot1Ready')) return;
var cfg = {};
try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {}
OT.MARKS.forEach(function (m) { if (m.kind === 'circle') m.photo = (cfg.photos || {})[m.id] || null; });
var hex = function (id) { return (OT.THREADS.filter(function (t) { return t.id === id; })[0] || {}).hex; };
each('[data-ot1-gstill]', cfgEl.closest('.shopify-section') || document, function (el) {
if (!once(el, 'ot1Ready')) return;
var p = el.getAttribute('data-ot1-gstill').split('.'), e = (OT.STITCHED_BOX || {})[p[0]];
var m = OT.MARKS.filter(function (x) { return x.id === p[1]; })[0];
if (!e || !m) return;
var good = m.nature === 'good', A = hex(good ? 'black' : 'white'), B = hex(good ? 'white' : 'black'), K = 1.035;
var cv = el.querySelector('canvas'), pc = function (v) { return v * 100 + '%'; };
function vector() {
var w = 2 * e[2] * K * VEC.w / (2 * VEC.r), h = 2 * e[3] * K * VEC.h / (2 * VEC.r), v = document.createElement('span');
v.className = 'ot1-gvec'; v.innerHTML = OT.markSVG(m.id);
v.style.cssText = 'left:' + pc(e[0] - w * VEC.cx / VEC.w) + ';top:' + pc(e[1] - h * VEC.cy / VEC.h) + ';width:' + pc(w) +
';height:' + pc(h) + ';--a:' + A + ';--b:' + B;
cv.hidden = true; el.appendChild(v);
}
Promise.resolve(m.photo && OT.threadModel ? OT.threadModel(m) : null).then(function (model) {
if (!model) { vector(); return; }
OT.threadPaint(model, cv, A, B);
var sx = e[2] * K / model.e.a, sy = e[3] * K / model.e.b;
cv.style.cssText = 'left:' + pc(e[0] - model.e.cx * sx) + ';top:' + pc(e[1] - model.e.cy * sy) + ';width:' + pc(model.w * sx) +
';height:' + pc(model.h * sy);
}).catch(vector).then(function () { el.classList.add('is-drawn'); });
});
});
}
function init(root) { studio(root); countdowns(root); marks(root); lineups(root); reviews(root); capCards(root); moreBuilds(root); cartThumbs(root); gridStills(root); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
else init(document);
document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
